import React, {createContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

export const LanguageContext = createContext();

export const LanguageProvider = ({children}) => {
    const {i18n} = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        setCurrentLanguage(language);
    };

    useEffect(() => {
        setCurrentLanguage(i18n.language);
    }, [i18n.language]);

    return (
        <LanguageContext.Provider value={{currentLanguage, changeLanguage}}>
            {children}
        </LanguageContext.Provider>
    );
};
